import type { ShapeType } from '../types/drawing.js';

/** CoT type codes for TAK shape events */
export const SHAPE_COT_TYPES = {
  POLYGON: 'u-d-f',
  RECTANGLE: 'u-d-r',
  CIRCLE: 'u-d-c-c',
  FREEFORM: 'u-d-f-m',
  ROUTE: 'b-m-r',
  WAYPOINT: 'b-m-p-w',
  CONTROL_POINT: 'b-m-p-c',
  RANGE_BEARING: 'u-rb-a',
} as const;

/** Prefix lookup for identifying inbound shape events (no regex) */
export const SHAPE_TYPE_PREFIX_MAP: ReadonlyMap<string, ShapeType> = new Map([
  ['u-d-f-m', 'freeform'],
  ['u-d-f', 'polygon'],
  ['u-d-r', 'rectangle'],
  ['u-d-c-c', 'circle'],
  ['b-m-r', 'route'],
  ['u-rb-a', 'measurement'],
]);

/** Route planning method options */
export const ROUTE_PLANNING_METHODS = ['Infil', 'Exfil', 'Patrol', 'Supply'] as const;

/** Route travel method options */
export const ROUTE_METHODS = ['Driving', 'Walking', 'Flying', 'Swimming'] as const;

/** Route direction options */
export const ROUTE_DIRECTIONS = ['Infil', 'Exfil'] as const;

/** Route classification options */
export const ROUTE_TYPES = ['Primary', 'Alternate', 'Emergency'] as const;

/** Geofence trigger conditions */
export const GEOFENCE_TRIGGERS = ['Entry', 'Exit', 'Both'] as const;

/** Geofence monitor target groups */
export const GEOFENCE_MONITORS = ['All', 'Friendly', 'Hostile'] as const;

/** Standard waypoint naming constants */
export const WAYPOINT_NAMES = {
  START: 'SP',
  END: 'VDO',
  PREFIX: 'CP',
} as const;
